import React from 'react'
import { Outlet } from 'react-router-dom'

function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-accent-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Dkard</h1>
          <p className="text-gray-600">Crea tu tarjeta digital profesional</p>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-8">
          <Outlet />
        </div>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">© 2024 Dkard. Todos los derechos reservados.</p>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
